/*
 * PlaquesAgraver - Apercu des visuels de production dans le panier.
 *
 * Remplace le bloc inline qui vivait en fin de layout/theme.liquid et qui
 * appelait /cart.js a chaque mutation du DOM (33 requetes par page mesurees).
 *
 * Regles :
 *  - aucune requete si la page ne contient pas d'image de panier
 *  - re-rendu depuis le cache, requete uniquement sur changement reel du panier
 *  - anti-rebond de 120 ms
 *  - l'observateur ne surveille que le conteneur du panier, pas tout le body
 */
(function () {
  'use strict';

  var lastCart = null;
  var timer = null;
  var running = false;

  function paint(cart) {
    var images = document.querySelectorAll('.cart-item__image');
    if (!images.length || !cart || !cart.items) return;
    cart.items.forEach(function (item, idx) {
      var url = item.properties && (item.properties['Fichier production'] || item.properties['_image']);
      if (!url) return;
      var img = images[idx];
      if (img && !img.classList.contains('pag-injected')) {
        img.src = url;
        img.srcset = '';
        img.style.objectFit = 'contain';
        img.style.background = '#fff';
        img.classList.add('pag-injected');
      }
    });
  }

  function run(force) {
    if (!document.querySelector('.cart-item__image')) return; // rien a peindre ici
    if (!force && lastCart) { paint(lastCart); return; }      // cache, zero requete
    if (running) return;
    running = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) { lastCart = cart; paint(cart); } })
      .catch(function () { /* silencieux : ne jamais casser la page */ })
      .then(function () { running = false; });
  }

  window.pagInjectCartPreview = function (force) {
    clearTimeout(timer);
    timer = setTimeout(function () { run(force === true); }, 120);
  };

  function boot() {
    window.pagInjectCartPreview(true);

    var host = document.querySelector('cart-drawer, cart-notification, #main-cart-items, .cart-items');
    if (host) {
      new MutationObserver(function () { window.pagInjectCartPreview(); })
        .observe(host, { childList: true, subtree: true });
    }

    ['cart:updated', 'cart-drawer:open', 'cart-drawer:after-open', 'cart:refresh']
      .forEach(function (ev) {
        document.addEventListener(ev, function () { window.pagInjectCartPreview(true); });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
